"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textColorFromBackgroundColor = textColorFromBackgroundColor;
exports.getFeedBodyColor = getFeedBodyColor;
exports.getFeedHeaderColor = getFeedHeaderColor;
exports.getFeedStyle = getFeedStyle;
function hexColorToDecimal(hexColor) {
    if (hexColor.startsWith('#')) {
        hexColor = hexColor.substring(1);
    }
    return [
        parseInt(hexColor.substring(0, 2), 16) / 255,
        parseInt(hexColor.substring(2, 4), 16) / 255,
        parseInt(hexColor.substring(4, 6), 16) / 255,
    ];
}
function hexColorToLuminance(hexColor) {
    const rgb = hexColorToDecimal(hexColor);
    return 0.2126 * Math.pow(rgb[0], 2.2) + 0.7152 * Math.pow(rgb[1], 2.2) + 0.0722 * Math.pow(rgb[2], 2.2);
}
function textColorFromBackgroundColor(hexColor) {
    return hexColorToLuminance(hexColor) < Math.pow(0.5, 2.2) ? 'light' : 'dark';
}
function getFeedBodyColor(theme, feed) {
    var _a, _b, _c, _d;
    if (theme === 'light') {
        return (_b = (_a = feed.style2) === null || _a === void 0 ? void 0 : _a.light) === null || _b === void 0 ? void 0 : _b.body_bg_color;
    }
    else {
        return (_d = (_c = feed.style2) === null || _c === void 0 ? void 0 : _c.dark) === null || _d === void 0 ? void 0 : _d.body_bg_color;
    }
}
function getFeedHeaderColor(theme, feed) {
    var _a, _b, _c, _d;
    if (theme === 'light') {
        return (_b = (_a = feed.style2) === null || _a === void 0 ? void 0 : _a.light) === null || _b === void 0 ? void 0 : _b.header_bg_color;
    }
    else {
        return (_d = (_c = feed.style2) === null || _c === void 0 ? void 0 : _c.dark) === null || _d === void 0 ? void 0 : _d.header_bg_color;
    }
}
function getFeedStyle(theme, feed) {
    var _a, _b;
    if (theme === 'light') {
        return (_a = feed.style2) === null || _a === void 0 ? void 0 : _a.light;
    }
    else {
        return (_b = feed.style2) === null || _b === void 0 ? void 0 : _b.dark;
    }
}
